import {ILanguage} from "../../../constants/Language";
import {IObjectType, ISyncField} from "../../../index";
import {ObjectTypeId} from "../../../constants";
import {IPermissionDefinition} from "../../../util/misc";
import {Group} from "./group";

interface IDataCollection {
    language: ILanguage
    data: ISyncField[]
}

type TMode = 'create' | 'read' | 'update' | 'delete';

type TKey = keyof ISyncField
type TObservable = KnockoutObservable<ISyncField[TKey]>

type TColumnsConfig = keyof Pick<ISyncField,
    'syncfieldid' |
    'name' |
    'required' |
    'issynced' |
    'ignorefilter' |
    'isoverridablebylevel'>
type TColumnsTranslation = keyof Pick<ISyncField,
    'core' |
    'description' |
    'displayname' |
    'fieldtype' |
    'parameters' |
    'referencefieldid' |
    'referenceobjecttypeid' |
    'syncfielddisplaynameid'>

interface IAvailableData {
    columnsConfig: KnockoutObservableArray<TColumnsConfig>
    columnsTranslation: KnockoutObservableArray<TColumnsTranslation>
    objectTypes: IObjectType[]
    groups: KnockoutObservableArray<Group>
    permissionDefinitions: IPermissionDefinition[]
    selectedImportFormatId: KnockoutObservable<ILanguage['id']>
    selectedLanguageId: KnockoutObservableArray<ILanguage['id']>
    selectedObjectTypeId: KnockoutObservable<ObjectTypeId>
}

interface ITableOptions {
    modes: TMode[]
    searchkey?: KnockoutObservable<string>
    sortcol?: keyof ISyncField
}